// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__LUwUn","more":"styles_more__Tcw90"};